/**
 * i18n entry point for Realty237 (FR default, EN available).
 * Default French; English only after the visitor picks it (localStorage).
 * Most UI strings are hardcoded French; in EN mode DomTranslator swaps them using
 * the static dictionary in ./dom/en.json (key public pages + user dashboard).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './locales/fr.json';
import en from './locales/en.json';

const LANG_KEY = 'realty237.lang';

// French by default; English only once the visitor picks it in the footer selector.
const detect = () => {
  try {
    return window.localStorage.getItem(LANG_KEY) === 'en' ? 'en' : 'fr';
  } catch {
    return 'fr';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    lng: typeof window !== 'undefined' && !window.location.pathname.startsWith('/admin') ? detect() : 'fr',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
}

// Persist the choice and reload so every hardcoded string re-renders in the right language.
export const setLanguage = (code) => {
  try { window.localStorage.setItem(LANG_KEY, code); } catch { /* ignore */ }
  if (code !== i18n.language) window.location.reload();
};

export const savedLanguage = detect;

export const SUPPORTED_LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export const LANG_STORAGE_KEY = LANG_KEY;
export default i18n;
